import TitleBlock, { TitleDescription } from '@anm/components/TitleBlock';
import IconButton from '@anm/components/buttons/IconButton';
import { blueDarkFilters, flexCenter } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export const Title = styled(TitleBlock)`
  max-width: unset !important;
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 21px;
    font-weight: bold;
    line-height: 30px !important;
    text-align: center;
    @media (orientation: landscape) {
      text-align: center;
    }
  }
  ${TitleDescription} {
    font-size: 14px;
    line-height: 22px !important;
    font-weight: normal;
    text-align: center;
    @media (orientation: landscape) {
      min-width: 382px;
      text-align: center;
    }
  }
`;

const centeredColumn = css`
  ${flexCenter};
  flex-direction: column;
`;

export const InfoContainer = styled.div`
  ${centeredColumn};
  @media (orientation: landscape) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const ButtonContainer = styled.div`
  ${centeredColumn};
  margin-top: 26px;
  @media (orientation: landscape) {
    margin-top: 19px;
  }
`;

export const ButtonsContainer = styled.div`
  ${centeredColumn};
  @media (orientation: landscape) {
    flex-direction: row;
    ${ButtonContainer}:last-child p {
      margin-left: auto;
    }
  }
`;

export const ButtonHint = styled.p<{ maxWidth: number }>`
  font-size: 14px;
  margin: 0 0 16px;
  line-height: 22px;
  text-align: center;
  font-weight: normal;
  @media (orientation: landscape) {
    max-width: ${({ maxWidth }) => maxWidth}px;
  }
`;

export const IconButtonWrapper = styled(IconButton)`
  max-width: 240px;
  &:before {
    ${blueDarkFilters};
  }
`;

export const ShareButtonWrapper = styled(IconButton)`
  font-size: 16px;
  max-width: 130px;
  font-weight: bold;

  &:before {
    margin-right: 12px;
  }
  @media (orientation: landscape) {
    margin-left: 20px;
  }
`;

const Wrapper = styled.div`
  padding: 2px 6px 10px;
  @media (orientation: landscape) {
    padding: 8px 0 0;
    max-width: 470px;
  }
`;

export default Wrapper;
